import WelcomeScreen from "../screen/WelcomeScreen";
import FormScreen from "../screen/FormScreen";
import FinishedScreen from "../screen/FinishedScreen";

export const routes = [
  {
    path: "/",
    Screen: WelcomeScreen,
    isProtected: false,
  },
  {
    path: "/form",
    Screen: FormScreen,
    isProtected: false,
  },
  {
    path: "/form/done",
    Screen: FinishedScreen,
    isProtected: false,
  },
];
